import classNames from 'clsx';
import type React from 'react';

import type { ProviderLogos } from '@swf/casino';
import type { WidgetType } from '@swf/core/types/Widget';

import styles from './CasinoProviderLogo.scss';
import { PROVIDER_LOGO_MAPPING } from './constants';

export interface Props {
  developer: ProviderLogos;
  contentType: WidgetType;
  customClassName?: string;
  className?: string;
}

const CasinoProviderLogo: React.FC<Props> = ({
  developer,
  contentType,
  className,
  customClassName
}) =>
  PROVIDER_LOGO_MAPPING?.[developer] && (
    <div
      className={classNames(className, styles.providerLogo, PROVIDER_LOGO_MAPPING[developer], {
        [styles.gameDeck]: contentType === 'casino_game_deck',
        [customClassName || '']: !!customClassName
      })}
    />
  );

export default CasinoProviderLogo;
